import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Row, Col } from 'react-bootstrap';
import { FiAlertTriangle, FiTrendingUp, FiCrosshair } from 'react-icons/fi';
import { fetchPoliciesTrips, fetchPoliciesActivities } from '../store/actions/dataActions';
import 'bootstrap/dist/css/bootstrap.css';
import './DashboardPages.css';

const Exposure = () => {
    const dispatch = useDispatch();
    const { policies } = useSelector(state => state.data);

    useEffect(() => {
        dispatch(fetchPoliciesTrips());
        dispatch(fetchPoliciesActivities());
    }, [dispatch]);

    const calculateExposure = () => {
        const allPolicies = [
            ...(policies.trips.data || []),
            ...(policies.activities.data || []),
        ];

        const totalExposure = allPolicies.reduce((sum, policy) => {
            const exposure = policy.sum_insured || policy.coverage_amount || 0;
            return sum + exposure;
        }, 0);

        const numberOfExposures = allPolicies.filter(
            p => (p.sum_insured || p.coverage_amount || 0) > 0
        ).length;

        const exposures = allPolicies.map(p => p.sum_insured || p.coverage_amount || 0);
        const avgExposure = exposures.length > 0 ? totalExposure / exposures.length : 0;

        return {
            totalExposure: totalExposure.toFixed(2),
            numberOfExposures,
            avgExposure: avgExposure.toFixed(2),
        };
    };

    const stats = calculateExposure();
    const loading = policies.trips.loading || policies.activities.loading;

    return (
        <div className="dashboard-page">
            <h2 className="page-header">Exposure</h2>
            <Row className="mb-4">
                <Col md={4}>
                    <Card className="stat-card stat-warning">
                        <Card.Body>
                            <div className="stat-content">
                                <FiAlertTriangle className="stat-icon" />
                                <div>
                                    <div className="stat-value">
                                        {loading ? '...' : `${stats.totalExposure} €`}
                                    </div>
                                    <div className="stat-label">Total exposure</div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="stat-card stat-warning">
                        <Card.Body>
                            <div className="stat-content">
                                <FiCrosshair className="stat-icon" />
                                <div>
                                    <div className="stat-value">
                                        {loading ? '...' : stats.numberOfExposures}
                                    </div>
                                    <div className="stat-label">Number of exposures</div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={4}>
                    <Card className="stat-card stat-warning">
                        <Card.Body>
                            <div className="stat-content">
                                <FiTrendingUp className="stat-icon" />
                                <div>
                                    <div className="stat-value">
                                        {loading ? '...' : `${stats.avgExposure} €`}
                                    </div>
                                    <div className="stat-label">Average exposure</div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Exposure;

